import { render, staticRenderFns } from "./HomeAdditionalComponent.vue?vue&type=template&id=4f357759"
import script from "./HomeAdditionalComponent.vue?vue&type=script&lang=js"
export * from "./HomeAdditionalComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeAdditionalComponent.vue?vue&type=style&index=0&id=4f357759&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports